<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Address Information</h6>
            <div class="row">
                <div v-if="address.id" class="col-lg-12 mb-4">
                    <google-map disabled :initial-value="initialAddress" :initial-location="initialAddress.position" ></google-map>
                </div>
                <div class="col-lg-12">
                    <div class="row">
                        <div class="col-lg-11">
                            <div class="text-xs">Unit/House no, Building, Street name</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="address.specification"></h3>
                        </div>
                        <div class="col-lg-11">
                            <div class="text-xs">Barangay</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="address.barangay"></h3>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <div class="text-xs">City/Municipality</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="address.city"></h3>
                        </div>
                        <div class="col-lg-5 col-sm-12">
                            <div class="text-xs">Province</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="address.province"></h3>
                        </div>
                        <div class="col-lg-6">
                            <div class="text-xs">Zipcode</div>
                            <h3 class="font-weight-700 text-default text-sm" v-text="address.zipcode"></h3>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import Form from "@models/components/Form";

export default {
    name: "AddressSection",

    computed: {
        initialAddress() {
            return {
                address: { ...this.address },
                position: {
                    lat: parseFloat(this.address.latitude || 0),
                    lng: parseFloat(this.address.longitude || 0),
                    radius: 0,
                }
            };
        },
    },

    methods: {},

    mixins: [mixins],

    props: {
        address: Object
    }
}
</script>